import {
  FETCH_COUNT_DATA_REQUEST,
  FETCH_COUNT_DATA_SUCCESS,
  FETCH_COUNT_DATA_FAILURE
} from './countDataTypes';

const initialState = {
  loading: false,
  data: [],
  error: ''
};

const countDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COUNT_DATA_REQUEST:
      return {
        ...state,
        loading: true
      };
    case FETCH_COUNT_DATA_SUCCESS:
      return {
        loading: false,
        data: action.payload,
        error: ''
      };
    case FETCH_COUNT_DATA_FAILURE:
      return {
        loading: false,
        data: [],
        error: action.payload
      };
    default:
      return state;
  }
};

export default countDataReducer;
